export const bedroomsList = [
  {
    id: 1,
    name: '1',
    selected: false,
  },
  {
    id: 2,
    name: '2',
    selected: false,
  },
  {
    id: 3,
    name: '3',
    selected: false,
  },
  {
    id: 4,
    name: '4',
    selected: false,
  },
  {
    id: 5,
    name: '5',
    selected: false,
  },
  {
    id: 6,
    name: '6',
    selected: false,
  },
];

export const bathroomsList = [
  {
    id: 1,
    name: '1',
    selected: false,
  },
  {
    id: 2,
    name: '2',
    selected: false,
  },
  {
    id: 3,
    name: '3',
    selected: false,
  },
  {
    id: 4,
    name: '4',
    selected: false,
  },
  {
    id: 5,
    name: '5',
    selected: false,
  },
  {
    id: 6,
    name: '6',
    selected: false,
  },
];

export const propertyTypeData = [
  {
    id: 1,
    name: 'Departamento',
    value: 'Departamento',
  },
  {
    id: 2,
    name: 'Casa',
    value: 'Casa',
  },
  {
    id: 3,
    name: 'Parcela',
    value: 'Parcela',
  },
  {
    id: 4,
    name: 'Bodega',
    value: 'Bodega',
  },
  {
    id: 5,
    name: 'Terreno',
    value: 'Terreno',
  },
  {
    id: 6,
    name: 'Estacionamientos',
    value: 'Estacionamientos',
  },
];
